export default __webpack_public_path__ + "static/cultura-59bf83ca1e4a0b1e0a4eb822d2c1d2ee.svg";